export default __webpack_public_path__ + "static/media/plus_icon.58c256f6.svg";